import { createReducer, on } from '@ngrx/store';
import { AccountTeamStripeRedirectActions } from './account-team-stripe-redirect.action';

export interface AccountTeamStripeRedirectState {
  showCancelButton: boolean;
}

export const initialState: AccountTeamStripeRedirectState = {
  showCancelButton: true,
};

export const accountTeamStripeRedirectReducer = createReducer(
  initialState,
  on(AccountTeamStripeRedirectActions.cancelButtonHidden, (state) => ({
    ...state,
    showCancelButton: false,
  })),
);
